import React from 'react';
import Slider from 'react-slick';
import hdfc from '../../assets/images/hdfc.png';
import icici from '../../assets/CompanyLogo/icici_logo.png';
import digit from '../../assets/CompanyLogo/Digit.png';
import care from '../../assets/CompanyLogo/Care.jpg';
import kotak from '../../assets/CompanyLogo/Kotak.jpg';
import orient from '../../assets/CompanyLogo/Oriental.png';
import bajaj from '../../assets/CompanyLogo/Bajaj.png';
import aditya from '../../assets/CompanyLogo/aditiya-birla-life-insurance-logo-web.jpg';
import chola from '../../assets/CompanyLogo/Chola MS.jpg';
import cigna from '../../assets/CompanyLogo/Cigna.png';
import future from '../../assets/CompanyLogo/Future Generali.png';
import ifco from '../../assets/CompanyLogo/iffco- Tokio.webp';
import reliance from '../../assets/CompanyLogo/Reliance.png';
import royal from '../../assets/CompanyLogo/Royal sundaram.png';
import sbi from '../../assets/CompanyLogo/SBI.png';
import shriram from '../../assets/CompanyLogo/Shriram.png';
import star from '../../assets/CompanyLogo/Star.png';
import tata from '../../assets/CompanyLogo/tata AIG.jpg';
import universe from '../../assets/CompanyLogo/Universalsompo.png';

const CompanySlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const bannerArray = [
    { url: hdfc },
    { url: icici },
    { url: care },
    { url: orient },
    { url: kotak },
    { url: digit },
    { url: shriram },
    { url: tata },
    { url: star },
    { url: universe },
    { url: orient },
    // { url: bajaj },
    { url: aditya },
    { url: chola },
    { url: cigna },
    { url: future },
    { url: ifco },
    { url: reliance },
    { url: royal },
    { url: sbi },
  ];

  return (
    <div>
      <link
        rel="stylesheet"
        type="text/css"
        charset="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />

      <div className="py-2 mx-4">
        <Slider {...settings}>
          {bannerArray.map((el, i) => (
            <div style={{ height: '800px', width: '150px' }} key={i}>
              <img
                src={el.url}
                style={{
                  height: '80px',
                  width: '150px',
                  objectFit:
                    el.url === cigna || el.url === chola || el.url === royal
                      ? 'cover'
                      : 'contain',
                  aspectRatio: '1/2',
                }}
                className="w-[150px] h-[200px] aspect-[3/2] object-contain"
                alt=""
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default CompanySlider;
